<template>
  <v-app>
      <Login v-if="!this.$store.state.authenticated"></Login>
      <Home v-if="this.$store.state.authenticated"></Home>
  </v-app>
</template>

<style lang="scss">
  @import "assets/styles/styles";
</style>

<script>
import Home from './views/Home.vue'
import Login from './views/Login.vue'

export default {
  name: 'App',
  components: {
    Home,
    Login
  },
  data: () => ({}),
  mounted () {
    this.$store.commit('checkAuth')
  }
}
</script>
